import { render } from "./DashBoardComp.vue?vue&type=template&id=1c278958&scoped=true"
import script from "./DashBoardComp.vue?vue&type=script&lang=js"
export * from "./DashBoardComp.vue?vue&type=script&lang=js"

import "./DashBoardComp.vue?vue&type=style&index=0&id=1c278958&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c278958"]])

export default __exports__